import { withCompInfo } from '../../core/withCompInfo'
import { CaptchaDefinition, CaptchaProps } from './types'
import { WIX_RECAPTCHA_LANGUAGE_MAP } from './constants'

export const props = withCompInfo<CaptchaProps, CaptchaDefinition>(['language'], ({ language }) => {
	return {
		language: WIX_RECAPTCHA_LANGUAGE_MAP[language],
	}
})
